import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';

// API URL 설정
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Projects 페이지 컴포넌트
function Projects() {
  const { isAdmin } = useAuth();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 데이터 가져오기
  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/projects`);
      const data = await response.json();

      if (data.success) {
        setProjects(data.data);
      } else {
        setError('Failed to load projects');
      }
    } catch (err) {
      console.error('Error fetching projects:', err);
      setError('Failed to connect to server');
    } finally {
      setLoading(false);
    }
  };

  // project_type별로 분류
  const ongoingProjects = projects.filter(p => p.project_type === 'ongoing');
  const completedProjects = projects.filter(p => p.project_type === 'completed');

  // 로딩 중
  if (loading) {
    return (
      <div className="site-content" style={{ textAlign: 'center', padding: '50px' }}>
        <p>Loading projects...</p>
      </div>
    );
  }

  // 에러 발생
  if (error) {
    return (
      <div className="site-content" style={{ textAlign: 'center', padding: '50px' }}>
        <p style={{ color: 'red' }}>{error}</p>
        <button onClick={fetchProjects}>Retry</button>
      </div>
    );
  }

  return (
    <div className="site-content">
      {/* Register 버튼 - 관리자에게만 표시 */}
      {isAdmin && (
        <div style={{ textAlign: 'right', margin: '20px 0' }}>
          <Link to="/register-project" style={{
            display: 'inline-block',
            padding: '8px 20px',
            backgroundColor: '#222',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '3px',
            fontSize: '14px',
            border: 'none'
          }}>
            Register a Project
          </Link>
        </div>
      )}

      <div className="container" style={{ width: '90%', margin: '0 auto' }}>
        {/* Ongoing Projects */}
        <section style={{ marginBottom: '50px' }}>
          <h3 style={{ fontSize: '1rem', fontWeight: 'bold', marginBottom: '10px' }}>On Going Projects</h3>
          <hr style={{ border: 'none', borderTop: '1px solid #ececec', marginBottom: '0' }} />
          
          {ongoingProjects.length > 0 ? (
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse',
              border: '1px solid #ddd'
            }}>
              <tbody>
                {ongoingProjects.map((project, index) => (
                  <tr key={project.ID} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ 
                      padding: '8px 10px',
                      fontSize: '15px',
                      lineHeight: '1.6',
                      backgroundColor: index % 2 === 0 ? '#f0f0f0' : '#ffffff',
                      border: '1px solid #ddd'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ flex: 1 }}>
                          <span style={{ color: '#555' }}>·&nbsp;&nbsp;</span>
                          {project.period && (
                            <span style={{ color: '#555' }}>[{project.period}]&nbsp;</span>
                          )}
                          {project.agency && (
                            <span style={{ color: '#555' }}>({project.agency})&nbsp;</span>
                          )}
                          <span>{project.title}</span>
                        </div>
                        {isAdmin && (
                          <Link 
                            to={`/edit-project/${project.ID}`}
                            style={{
                              padding: '4px 10px',
                              fontSize: '12px',
                              backgroundColor: '#0066cc',
                              color: '#fff',
                              textDecoration: 'none',
                              borderRadius: '3px',
                              whiteSpace: 'nowrap',
                              marginLeft: '10px'
                            }}
                          >
                            Edit
                          </Link>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: '#666', fontStyle: 'italic', marginTop: '20px' }}>No ongoing projects</p>
          )}
        </section>

        {/* Completed Projects */}
        <section>
          <h3 style={{ fontSize: '1rem', fontWeight: 'bold', marginBottom: '10px', marginTop: '40px' }}>Completed Projects</h3>
          <hr style={{ border: 'none', borderTop: '1px solid #ececec', marginBottom: '0' }} />
          
          {completedProjects.length > 0 ? (
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse',
              border: '1px solid #ddd'
            }}>
              <tbody>
                {completedProjects.map((project, index) => (
                  <tr key={project.ID} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ 
                      padding: '8px 10px',
                      fontSize: '15px',
                      lineHeight: '1.6',
                      backgroundColor: index % 2 === 0 ? '#f0f0f0' : '#ffffff',
                      border: '1px solid #ddd'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ flex: 1 }}>
                          <span style={{ color: '#555' }}>·&nbsp;&nbsp;</span>
                          {project.period && (
                            <span style={{ color: '#555' }}>[{project.period}]&nbsp;</span>
                          )}
                          {project.agency && (
                            <span style={{ color: '#555' }}>({project.agency})&nbsp;</span>
                          )}
                          <span>{project.title}</span>
                        </div>
                        {isAdmin && (
                          <Link 
                            to={`/edit-project/${project.ID}`}
                            style={{
                              padding: '4px 10px',
                              fontSize: '12px',
                              backgroundColor: '#0066cc',
                              color: '#fff',
                              textDecoration: 'none',
                              borderRadius: '3px',
                              whiteSpace: 'nowrap',
                              marginLeft: '10px'
                            }}
                          >
                            Edit
                          </Link>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ color: '#666', fontStyle: 'italic', marginTop: '20px' }}>No completed projects</p>
          )}
        </section>
      </div>
    </div>
  );
}

export default Projects;
